"use client"

import { useEffect, useState } from "react"
import Script from "next/script"

import { getSbLocaleFromHostAndUri } from "@/lib/locale-helper"

export default function AbTastyScriptClient() {
  const [abTastyTag, setAbTastyTag] = useState<string | undefined>()

  useEffect(() => {
    const sbLocale = getSbLocaleFromHostAndUri(window.location.hostname, window.location.pathname)
    const url = new URL(`${process.env.NEXT_PUBLIC_BASE_PATH ?? ""}/api/storefront/abtasty-tag`, window.location.origin)
    url.searchParams.set("sbLocale", sbLocale)

    fetch(url.toString())
      .then((response) => (response.ok ? response.json() : undefined))
      .then((data: { tag?: string } | undefined) => {
        if (data?.tag) {
          setAbTastyTag(data.tag)
        }
      })
      .catch(() => undefined)
  }, [])

  if (!abTastyTag) {
    return null
  }

  return <Script src={`https://try.abtasty.com/${abTastyTag}.js`} strategy="afterInteractive" />
}
